import React from 'react';
import TopMenu from '@src/business-components/top-menu';
import NewsDetailsStore from './store';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import Page from '@src/components/page';
import cx from 'classnames';
import CommonFooter from '@src/business-components/common-footer';

import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import formatLocaleDate from '@src/utils/format-locale-date';
import toWebpImage from '@src/utils/to-webp-image';
import redirect from '@src/utils/redirect-if-mobile-accress';
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();
const lang = getLanguageByPath();

const NewsDetail = ({ store }) => {
  //console.log(' NewsDetail   store:', store);

  store.use();
  return (
    <Page className={cx(styles.root, 'page-main')}>
      <TopMenu />
      <div
        className={styles.backBtn}
        onClick={() => {
          store.goBack();
        }}
        style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.Lang() + '/back.png'))})` }}
      />
      <div className={styles.container}>
        <div className={styles.title}>{store.title}</div>
        <div className={styles.creatTime}>
          {/* <span>{store.tabName[store.tab_key]}&nbsp;</span> */}
          {formatLocaleDate(store.createTimestamp)}
        </div>
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: store.content }} />
        {/* 底栏 */}
        <div className={styles.footerBox}>
          <CommonFooter store={store.CommonFooterStore} />
        </div>
      </div>
    </Page>
  );
};

export default wrapStore(NewsDetail, NewsDetailsStore);
